module.exports = __webpack_public_path__ + "img/huxingdidark.9783c0b0.svg";